'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _currencies = require('../../../../common/utils/currencies');

var _index = require('../../../../product-list/product-details/index');

var _index2 = _interopRequireDefault(_index);

var _cart = require('ifeis-isomorphic/lib/redux/actions/cart');

var _feiseanna = require('ifeis-isomorphic/lib/redux/actions/feiseanna');

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _products = require('ifeis-isomorphic/lib/redux/actions/products');

var _setMusic = require('ifeis-isomorphic/lib/redux/actions/setMusic');

var _updateRegistration = require('ifeis-isomorphic/lib/redux/actions/events/updateRegistration');

var _updateRegistration2 = _interopRequireDefault(_updateRegistration);

var _getFeisParticipantByDancerId = require('ifeis-isomorphic/lib/redux/actions/person/getFeisParticipantByDancerId');

var _getFeisParticipantByDancerId2 = _interopRequireDefault(_getFeisParticipantByDancerId);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _mapStateToSetDialogController = require('./mapStateToSetDialogController');

var _mapStateToSetDialogController2 = _interopRequireDefault(_mapStateToSetDialogController);

var _getEventRegistrationForPerson = require('ifeis-isomorphic/lib/redux/actions/events/getEventRegistrationForPerson');

var _getEventRegistrationForPerson2 = _interopRequireDefault(_getEventRegistrationForPerson);

var _cartStyles = require('./cart.styles.scss');

var _cartStyles2 = _interopRequireDefault(_cartStyles);

require('v-accordion');

require('v-accordion/dist/v-accordion.min.css');

require('../../../../immutables');

require('../../../../payment-form');

require('../../../../common/common.module.js');

require('../../../../router-history');

require('../../../../empty-state');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventTypeNames = {
  'G': 'Grades',
  'F': 'Figures',
  'C': 'Championships',
  'S': 'Specials'
};

var Prototype = {
  eventTypeNames: eventTypeNames,
  loadingStates: {
    registrations: []
  },

  go: function go(page) {
    // using this method prevents a reload when we transition between pages of the register area.
    this.$state.transitionTo('feiseanna.one.register', { page: page }, {
      inherit: true,
      notify: false
    });
  },
  isOwnAccount: function isOwnAccount() {
    return (0, _immutable.is)(this.account, this.currentUser);
  },
  loading: function loading() {
    if (this.groupFeesLoading || this.account.get('loading') || this.currentUser.get('loading')) {
      return true;
    }

    switch (this.currentPage) {
      case 'cart':
        return !!this.dependents.get('loading') || !!this.cart.get('loading') || !!this.products.get('loading');
      case 'competitions':
        if (this.currentPerson) {
          return !!this.cart.get('loading') || !!this.eventsForPerson.getIn([this.currentPerson.get('id'), 'loading']);
        }

        return !!this.dependents.get('loading');
    }

    return false;
  },
  isEditable: function isEditable() {
    var isEditable = true;

    var regEndMillis = this.feis.get('dt_reg_end');

    if (regEndMillis !== null) {
      var regEndDate = (0, _moment2.default)(regEndMillis);

      var isGodOrHasRoles = this.isGod || this.metadata.grants.indexOf('chair') !== -1 || this.metadata.grants.indexOf('registration') !== -1;

      // check if the feis is finalized or registration has ended and they are not a god or do not have a registration role
      if (this.feis.get('is_finalized')) {
        isEditable = false;
      } else if ((0, _moment2.default)().isAfter(regEndDate) && !isGodOrHasRoles) {
        isEditable = false;
      }
    }

    return isEditable;
  },
  getEventsRegistrationsMaxReachedText: function getEventsRegistrationsMaxReachedText(eventType) {
    if (eventType === 'G' && this.gradesCapReachedMessage) {
      return this.gradesCapReachedMessage;
    }

    if (eventType === 'C') {
      if (this.champsCapReachedMessage) return this.champsCapReachedMessage;
      if (this.prelimsCapReachedMessage && !this.champsCapReachedMessage) return this.prelimsCapReachedMessage;
      if (this.openChampCapReachedMessage && !this.champsCapReachedMessage) return this.openChampCapReachedMessage;
    }
    return '';
  },
  emptyCart: function emptyCart() {
    return !this.loading() && !this.persons_reged.size && !this.purchases.size && !this.assessments.size && !this.payments.size;
  },
  hasNoCompetitors: function hasNoCompetitors() {
    return !this.loading() && !this.currentPerson && !this.registerablePersons.size > 0;
  },
  noAvailableCompetitions: function noAvailableCompetitions() {
    return !this.loading() && !this.eventsForPerson.get(this.currentPerson.get('id')).size;
  },
  getPersonName: function getPersonName(id) {
    var person = id;

    if (typeof id === 'string') {
      person = this.getPersonFromId(id);
    }

    if ((0, _immutable.is)(person, this.account) && this.isOwnAccount()) {
      return 'You';
    }
    return person.get('fname') + ' ' + person.get('lname');
  },
  getPersonFromId: function getPersonFromId(id) {
    if (id === this.account.get('id')) {
      return this.account;
    }

    return this.dependents.find(function (d) {
      return d.get('id') === id;
    });
  },
  getEventName: function getEventName(event) {
    return (0, _ifeisIsomorphic.getDescription)(event.toJS());
  },
  getEventFee: function getEventFee(ev) {
    return typeof ev.get('fee') === 'number' ? ev.get('fee') : this.feis.get('event_fee');
  },
  registrationsForPerson: function registrationsForPerson(id) {
    return this.registrationsByNoGroupFees.get(id);
  },
  groupedRegistrationsForPerson: function groupedRegistrationsForPerson(id) {
    return this.registrationsByGroupFees.get(id);
  },
  groupedFeeForPerson: function groupedFeeForPerson(id) {
    return Object.keys((this.registrationsByGroupFees.get(id) || (0, _immutable.List)()).toJS() || []).sort(function (a, b) {
      return a - b;
    });
  },
  registeredForEvent: function registeredForEvent(pid, eid) {
    if (typeof eid !== 'string') {
      eid = eid.get('id');
    }

    if (typeof pid !== 'string') {
      pid = pid.get('id');
    }

    return (this.registrationsByGroupFees.get(pid) || (0, _immutable.List)()).valueSeq().find(function (i) {
      return i.find(function (e) {
        return e.get('event') === eid;
      });
    }) || (this.registrationsByNoGroupFees.get(pid) || (0, _immutable.List)()).valueSeq().find(function (i) {
      return i.get('event') === eid;
    });
  },
  showDanceAndMusicOptions: function showDanceAndMusicOptions(person, event) {
    var _this = this;

    this.$ngRedux.dispatch((0, _setMusic.getDances)());

    this.$mdDialog.show({
      locals: {
        person: person,
        event: event,
        feis: this.feis,
        updateRegistration: _updateRegistration2.default
      },
      controller: function controller($ngRedux, $scope, locals) {
        $scope.feis = locals.feis;
        $scope.person = locals.person.toJS();
        if (!$scope.person.reg) {
          $scope.person.reg = {};
        }
        $scope.event = locals.event;
        $scope.regChanged = false;

        $scope.cancel = function () {
          return _this.$mdDialog.cancel();
        };

        $scope.savePersonRegistration = function ($event) {
          $ngRedux.dispatch(locals.updateRegistration($scope.feis.get('id'), $scope.event.get('id'), $scope.person.id, $scope.person.reg)).then(function () {
            return $scope.cancel();
          });
        };

        $scope.changeRegValue = function () {
          $scope.regChanged = true;
        };

        $scope.toggleRegValue = function (prop) {
          $scope.changeRegValue();
          if ($scope.person.reg[prop] !== 1) {
            $scope.person.reg[prop] = 1;
          } else {
            $scope.person.reg[prop] = 0;
          }
        };

        var mapEventsPropertiesDialog = (0, _mapStateToSetDialogController2.default)($scope.feis.get('id'), $scope.event.get('id'), $scope.person);

        $ngRedux.connect(function (state) {
          var eventsPropertiesDialog = mapEventsPropertiesDialog(state);

          return _extends({}, eventsPropertiesDialog);
        })($scope);
      },
      template: require('./set-dance-info-modal.html'),
      clickOutsideToClose: true,
      fullscreen: this.$mdMedia('md')
    });
  },
  toggleRegisteredForEvent: function toggleRegisteredForEvent(person, event) {
    var _this2 = this;

    if (typeof person === 'string') {
      person = this.getPersonFromId(person);
    }

    var eid = event.get('id') || event.get('event');
    var pid = person.get('id');
    var fid = this.feis.get('id');
    var aid = this.account.get('id');

    this.loadingStates.registrations.push({ event: event, person: person });

    var stopLoading = function stopLoading() {
      return _this2.loadingStates.registrations = _this2.loadingStates.registrations.filter(function (i) {
        return !(0, _immutable.is)(person, i.person) || !(0, _immutable.is)(event, i.event);
      });
    };

    var stopLoadingAndRegisterDances = function stopLoadingAndRegisterDances(response) {
      stopLoading();

      var eventFoundInResponseForCurrentPerson = response.payload.debits.items.some(function (i) {
        return i.event === event.get('id') && _this2.currentPerson.get('id') === i.person;
      });

      if (eventFoundInResponseForCurrentPerson && (event.get('description').toLowerCase().includes('set') || event.get('type') === 'C' && event.get('rounds') === 3)) {
        _this2.getRegistrationsForEvent(event, pid);
      }
    };

    if (this.registeredForEvent(pid, eid)) {
      return this.$ngRedux.dispatch((0, _cart.unregisterForEvent)(fid, eid, aid, pid)).then(stopLoading);
    }

    return this.$ngRedux.dispatch((0, _cart.registerForEvent)(fid, eid, aid, pid)).then(function (response) {
      return stopLoadingAndRegisterDances(response);
    });
  },
  isRegisterRunning: function isRegisterRunning(p, ev) {
    return !!this.loadingStates.registrations.find(function (i) {
      return (0, _immutable.is)(p, i.person) && (0, _immutable.is)(ev, i.event);
    });
  },
  makePayment: function makePayment(event) {
    var _this3 = this;

    this.fPaymentFormDialog(event, this.cart.get('balance'), this.account.toJS(), this.feis.toJS(), false, this.estimatedCreditCardFee).then(function () {
      return _this3.$ngRedux.dispatch((0, _cart.updateCart)(_this3.feis.get('id'), _this3.account.get('id'), true, true));
    });
  },
  getRegistrationsForEvent: function getRegistrationsForEvent(item, pid) {
    var _this4 = this;

    this.$ngRedux.dispatch((0, _getEventRegistrationForPerson2.default)(this.feis.get('id'), item.get('id') || item.get('event'), item.get('person') || pid)).then(function (response) {
      _this4.showDanceAndMusicOptions((0, _immutable.Map)({ id: item.get('person') || pid, reg: response.payload.length > 0 && response.payload[0].reg || undefined }), (0, _immutable.Map)({ id: item.get('id') || item.get('event'), description: item.get('description') }));
    });
  },
  printCompetitorCards: function printCompetitorCards(pid) {
    var _this5 = this;

    return this.$ngRedux.dispatch((0, _getFeisParticipantByDancerId2.default)(this.feis.get('id'), pid)).then(function (response) {
      return response.payload && _this5.fPrintCompCards(_this5.feis.get('id'), response.payload) || _this5.msgService.displayErrorMsg('Could not print the dancers competitor number. Please contact ifeis supprot.');
    });
  },


  /**
   * Products
   */
  purchaseProduct: function purchaseProduct(product_id) {
    var _this6 = this;

    this.$ngRedux.dispatch((0, _cart.purchaseProduct)(this.feis.get('id'), this.account.get('id'), product_id)).then(function () {
      return _this6.msgService.displaySuccessMsg('Product added to cart');
    }).catch(function () {
      return _this6.msgService.displayErrorMsg('Could not add to cart');
    });
  },
  returnProduct: function returnProduct(purchase) {
    var pid = purchase.get('id');
    var fid = this.feis.get('id');
    var aid = this.account.get('id');

    this.$ngRedux.dispatch((0, _cart.returnProduct)(fid, aid, pid));
  },


  /**
   * Competitions
   */
  setCurrentPerson: function setCurrentPerson(person_id) {
    var _this7 = this;

    delete this.eventsForCurrentPerson;
    delete this.eventsByType;
    delete this.eventsByTypeAndGroupFee;
    delete this.eventsByTypeWithNoGroupFee;
    delete this.groupFeesByEventType;

    if (!person_id) {
      delete this.currentPerson;
      return;
    }

    this.currentPerson = this.getPersonFromId(person_id);

    // make sure we have cart, so we have the registrations
    this.$ngRedux.dispatch((0, _cart.updateCart)(this.feis.get('id'), this.account.get('id'), true, true));

    // make sure we have a cache of events to which this person is eligible
    this.$ngRedux.dispatch((0, _events.getEligibleEventsForPerson)(this.feis, this.currentPerson)).then(function () {
      return _this7.getEventsForCurrentPerson();
    });
  },
  getEventsForCurrentPerson: function getEventsForCurrentPerson() {
    if (!this.eventsForCurrentPerson) {
      this.eventsForCurrentPerson = this.eventsForPerson.get(this.currentPerson.get('id'));

      this.eventsByType = this.eventsForCurrentPerson.reduce(function (map, event) {
        var list = map.get(event.get('type')) || (0, _immutable.List)();

        list = list.push(event);
        return map.set(event.get('type'), list);
      }, (0, _immutable.Map)());

      this.eventTypes = this.eventsByType.keySeq().toJS();

      this.eventsByTypeWithNoGroupFee = this.eventsForCurrentPerson.reduce(function (map, event) {
        if (!event.get('groupFeeId')) {
          var eventType = event.get('type');
          var list = map.get(eventType) || (0, _immutable.List)();

          list = list.push(event);
          return map.set(eventType, list);
        } else {
          return map;
        }
      }, (0, _immutable.Map)());

      this.eventsByTypeAndGroupFee = this.eventsForCurrentPerson.reduce(function (map, event) {
        if (event.get('groupFeeId')) {
          var groupFeeId = event.get('groupFeeId');
          var eventType = event.get('type');
          var list = map.getIn([eventType, groupFeeId]) || (0, _immutable.List)();

          list = list.push(event);
          return map.setIn([eventType, groupFeeId], list);
        } else {
          return map;
        }
      }, (0, _immutable.Map)());

      this.groupFeesByEventType = this.eventsForCurrentPerson.reduce(function (map, event) {
        if (event.get('groupFeeId')) {
          var groupFeeId = event.get('groupFeeId');
          var eventType = event.get('type');
          var list = map.get(eventType) || (0, _immutable.List)();

          if (!list.some(function (l) {
            return l === groupFeeId;
          })) {
            list = list.push(groupFeeId);
          }

          return map.set(eventType, list);
        } else {
          return map;
        }
      }, (0, _immutable.Map)());
    }

    return this.eventsForCurrentPerson;
  },
  traverseToProductDetails: function traverseToProductDetails(product_id) {
    var product = this.products.find(function (p) {
      return p.get('id') === product_id;
    });
    this.showProductDetailsDialog(product);
  },
  showProductDetailsDialog: function showProductDetailsDialog(product) {
    this.$mdDialog.show({
      escapeToClose: true,
      controllerAs: '$ctrl',
      controller: _index2.default,
      template: require('../../../../product-list/product-details/tpl.html'),
      bindToController: true,
      locals: {
        product: product.toJS()
      }
    });
  },
  getImageUrl: function getImageUrl(product_id) {
    var product = this.products.find(function (p) {
      return !p.get('loading') && p.get('id') === product_id;
    });
    return product && product.getIn(['images', 0, 'url']);
  },
  findGroupFeeName: function findGroupFeeName(feeId) {
    var groupFeeName = (this.groupFees.find(function (g) {
      return g.get('id') === feeId;
    }) || (0, _immutable.Map)()).get('name');
    return groupFeeName && groupFeeName + ' - Flat Fee' || '';
  },
  findGroupFeeAmount: function findGroupFeeAmount(feeId) {
    return (this.groupFees.find(function (g) {
      return g.get('id') === feeId;
    }) || (0, _immutable.Map)()).get('amount');
  }
};

var RegisterController = function RegisterController(account, isGod, metadata, feis, $stateParams, $ngRedux, $rootScope, $state, msgService, fPaymentFormDialog, $mdDialog, $mdMedia, fPrintCompCards) {
  var ctrl = Object.assign({
    $state: $state,
    $ngRedux: $ngRedux,
    msgService: msgService,
    isGod: isGod,
    metadata: metadata,
    fPaymentFormDialog: fPaymentFormDialog,
    $mdDialog: $mdDialog,
    $mdMedia: $mdMedia,
    feis: (0, _immutable.fromJS)(feis), // FIXME(joshdmiller): this should be done in the upstream resolve
    currentPage: $stateParams.page,
    currencyDescription: (0, _currencies.getCurrencyDescription)(feis.currency),
    fPrintCompCards: fPrintCompCards
  }, Prototype);

  var accountIdToShow = account.id;

  if ($stateParams.account && $stateParams.account !== account.id) {
    accountIdToShow = $stateParams.account;
    $ngRedux.dispatch((0, _accounts.getAccount)($stateParams.account));
  }

  $ngRedux.dispatch((0, _accounts.getAccount)(account.id));
  $ngRedux.dispatch((0, _feiseanna.getGroupFeesForFeis)(ctrl.feis.get('id')));
  $ngRedux.connect((0, _mapStateToController2.default)(ctrl.feis, accountIdToShow, account.id))(ctrl);

  /**
   * The NavBar is setting the `currentPage` variable, and we have all refreshing/notifying from
   * ui-router turned off, so we just watch that property instead to fetch requisite data on page
   * change.
   */
  $rootScope.$watch(function () {
    return ctrl.currentPage;
  }, function (page) {
    switch (page) {
      case 'cart':
        $ngRedux.dispatch((0, _cart.updateCart)(feis.id, accountIdToShow, true, true));
        $ngRedux.dispatch((0, _products.getProductsAndImages)(feis.id, $ngRedux.getState));
        break;
      case 'competitions':
        $ngRedux.dispatch((0, _accounts.getDependents)(accountIdToShow));
        break;
    }
  });

  return ctrl;
};

exports.default = angular.module('ifeis.routes.feiseanna.one.register', ['ngMaterial', 'ui.router', 'vAccordion', 'ifeis.immutables', 'ifeis.common', 'ifeis.payment-form', 'ifeis.empty-state', 'ifeis.printing.compcards']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.register', {
    url: '/register/:page?account',
    params: {
      page: {
        squash: true,
        dynamic: true,
        value: 'cart'
      }
    },
    reloadOnSearch: false,
    template: require('./tpl.html'),
    controller: 'RegisterController',
    controllerAs: 'register',
    resolve: {
      isGod: function isGod(fSession) {
        return fSession.isGod();
      },
      account: function account(fSession, fAccountService) {
        return fSession.user().then(function () {
          return fAccountService.me();
        }).then(function (acct) {
          return acct.get();
        });
      }
    },
    ncyBreadcrumb: {
      label: '{{ register.isOwnAccount() ? "Register" : "Registrations by " + register.getPersonName( register.account ) }}',
      parent: 'feiseanna.one.landing-page'
    }
  });
}).directive('fCartLineItem', function () {
  return {
    restrict: 'E',
    template: require('./cart-line-item.tpl.html'),
    controller: function controller($scope, $attrs) {
      $scope.removable = !!$attrs.onRemove;
      $scope.loading = false;

      $scope.remove = function () {
        $scope.loading = true;
        $scope.onRemove().then(function () {
          return $scope.loading = false;
        });
      };
    },
    scope: {
      item: '=',
      onRemove: '&',
      showDate: '=',
      isEditable: '&',
      type: '@',
      onClickTraversal: '&',
      productUrl: '=',
      onGetRegistrations: '&'
    }
  };
}).controller('RegisterController', RegisterController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/register/index.js
// module id = 588
// module chunks = 0